import styled from 'styled-components';

import { StyleColor } from '../../../../../../../utils/styles-constants';
import { hexToRgba } from '../../../../../../../utils/style';
import { SlideTextPosition, SlideTextXPosition, SlideTextYPosition } from '../../../../../../../containers/Editor/utils/indesignEditor/editableSliders/getData';

interface ImageWrapperProps {
	width: number;
	height: number;
}

interface ImageProps {
	shouldScale: boolean;
}

interface TextWrapperProps {
	position: SlideTextPosition;
	isBackgroundSlide?: boolean;
}

interface TextProps {
	fontFamily: string;
	size: number;
	color: string;
	backgroundColor?: string;
	shadowColor?: string;
	position: SlideTextPosition;
}

interface ArrowProps {
	isRight?: boolean;
}

interface DotsProps {
	itemsLength: number;
}

const Wrapper = styled('div')`
	position: relative;
	display: flex;
	flex-direction: column;
	overflow: hidden;
`;

const ImageWrapper = styled('div')`
	box-sizing: border-box;
	position: relative;
	width: 100%;
	padding-top: ${({ width, height }: ImageWrapperProps) => `${(height / width) * 100}%`};
	border: 1px solid ${StyleColor.White};
	border-radius: 6px;
	overflow: hidden;
`;

const Image = styled('img')`
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	width: auto;
	height: auto;
	max-width: 100%;
	max-height: 100%;
	margin: auto;

	${({ shouldScale }: ImageProps) => shouldScale && `
		width: 100%;
		height: 100%;
		object-fit: cover;
	`}
`;

const TextWrapper = styled('div')`
	position: ${({ position: { y } }: TextWrapperProps) => (
		[
			SlideTextYPosition.ABOVE_SLIDE,
			SlideTextYPosition.UNDER_SLIDE,
		].includes(y) ? 'static' : 'absolute'
	)};
	display: flex;
	align-items: center;
	width: 100%;

	${({ position: { x } }: TextWrapperProps) => {
		switch (x) {
			case SlideTextXPosition.LEFT:
				return 'justify-content: flex-start;';
			case SlideTextXPosition.CENTER:
				return 'justify-content: center;';
			case SlideTextXPosition.RIGHT:
				return 'justify-content: flex-end;';
		}
	}}

	${({ position: { y }, isBackgroundSlide }: TextWrapperProps) => {
		switch (y) {
			case SlideTextYPosition.BOTTOM:
				return `bottom: ${isBackgroundSlide ? 0 : 20}px;`;
			case SlideTextYPosition.CENTER:
				return `
					top: 50%;
					transform: translateY(-50%);
				`;
			case SlideTextYPosition.TOP:
				return 'top: 0;';
			case SlideTextYPosition.ABOVE_SLIDE:
				return 'order: -1;';
			case SlideTextYPosition.UNDER_SLIDE:
				return '';
		}
	}}
`;

const Text = styled('span')`
	padding: 5px;
	font-family: ${({ fontFamily }: TextProps) => fontFamily};
	font-size: ${({ size }: TextProps) => `${size}px`};
	line-height: 1.2;
	color: ${({ color }: TextProps) => color};
	${({ backgroundColor }: TextProps) => backgroundColor && `background-color: ${backgroundColor}`};
	${({ shadowColor }: TextProps) => shadowColor && `text-shadow: 1px 1px 2px ${shadowColor}`};

	${({ position: { x } }: TextProps) => {
		switch (x) {
			case SlideTextXPosition.LEFT:
				return 'text-align: left;';
			case SlideTextXPosition.CENTER:
				return 'text-align: center;';
			case SlideTextXPosition.RIGHT:
				return 'text-align: right;';
		}
	}}
`;

const Dots = styled('div')`
	position: absolute;
	bottom: 5px;
	left: 50%;
	transform: translateX(-50%);
	display: flex;
	align-items: center;
	width: ${({ itemsLength }: DotsProps) => `${itemsLength * 11}px`};
`;

const Dot = styled('span')`
	flex: 0 0 6px;
	height: 6px;
	margin: 2px 2.5px;
	border-radius: 50%;
	background: ${StyleColor.White};
	opacity: 0.6;
	box-shadow: 1px 1px 2px 1px ${hexToRgba(StyleColor.Black, 30)};
`;

const Arrow = styled('div')`
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	display: flex;
	align-items: center;
	justify-content: center;
	width: 27px;
	height: 27px;
	border-radius: 8px;
	background: ${hexToRgba(StyleColor.White, 90)};

	${({ isRight }: ArrowProps) => isRight ? 'right: 5px;' : 'left: 5px;'};

	svg {
		width: 8px;
		height: 8px;
		fill: ${StyleColor.Black};

		${({ isRight }: ArrowProps) => isRight && 'transform: rotate(180deg);'};
	}
`;

export {
	Wrapper,
	ImageWrapper,
	Image,
	TextWrapper,
	Text,
	Dots,
	Dot,
	Arrow,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/SliderManager/Slide/TextEditor/SlidePreview/styles.ts